module.exports = __webpack_public_path__ + "img/avatar.09e47b5b.jpg";